<template>
  <div class="highlight-container highlight-height px-4 py-6">
    <div class="highlight-wrapper">
      <div class="matches-box">
        <div v-for="(league, index) in matchesHighlights" :key="index">
          <div v-if="matchUp(league) == 'Live'" class="matchUp">
            <div>Live</div>
            <img loading="lazy" width="70" height="20" alt="live match" src="/static/image/favourite/now.webp" />
          </div>
          <div v-else-if="matchUp(league) == 'Pre-match'" class="matchUp">
            <div>Pre-Match</div>
          </div>
          <div v-else class="matchUp">
            <div>Match Hot</div>
            <img loading="lazy" width="70" height="20" alt="hot match" src="/static/image/favourite/hot.webp" />
          </div>
          <a class="match-item pt-0" :class="$vuetify.breakpoint.mdAndUp ? 'mr-5' : 'mr-3'" :href="routeName.CRICKET">
            <div class="live_container">
              <div class="league-name match-datetime-div" style="display: flex; gap: 25px">
                <span>{{ league.league_name }}</span>
                <span>{{ league.matchDate }} {{ league.matchTime }}</span>
              </div>
            </div>
            <div class="match-team pa-2">
              <div class="home-team">
                <div>
                  <img loading="lazy" class="country-logo" :src="league.home_logo" />
                </div>
                <div class="team-name">{{ league.home_team }}</div>
                <div class="odds">{{ parseFloat(league.home_odds).toFixed(2) }}</div>
              </div>
              <div class="verDiv">
                <img loading="lazy" class="versus" src="/static/image/favourite/versus.png" />
              </div>
              <div class="away-team">
                <div>
                  <img loading="lazy" class="country-logo" :src="league.away_logo" />
                </div>
                <div class="team-name">{{ league.away_team }}</div>
                <div class="odds">{{ parseFloat(league.away_odds).toFixed(2) }}</div>
              </div>
            </div>
            <!--            <div class="match-datetime-div">-->
            <!--              <div class="match-date">{{ league.matchDate }}</div>-->
            <!--              <div class="match-time">{{ league.matchTime }}</div>-->
            <!--            </div>-->
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { uiHelper } from '@/util'
import { SHARED } from '@/constants/constants'
import { GAME_MATCHES_HIGHLIGHTS } from '@/store/game.module'
import { ROUTE_NAME } from '@/constants/route.constants'
import orderBy from 'lodash/orderBy'
import take from 'lodash/take'

export default {
  name: 'appHomeHighlight',
  data: () => ({
    highlights: null,
    routeName: ROUTE_NAME,
    desktopHighlights_1: [],
    desktopHighlights_2: [],
    currentHightlight_1: 0,
    currentHightlight_2: 0,
    startTime: SHARED.DEFAULT_START_TIME,
    endTime: SHARED.DEFAULT_END_TIME
  }),
  created() {
    this.getMatchesHighlights()
  },
  computed: {
    matchesHighlights() {
      let k = this.$store.state.game.matchesHighlights.filter(x => x.match_date >= this.startTime)
      k = orderBy(k, ['match_date'], ['asc'])
      k = take(k, 7)
      const n = Math.ceil(k.length / 2)
      this.desktopHighlights_1 = k.slice(0, n)
      this.desktopHighlights_2 = k.slice(n)
      k = k.map(function(league) {
        let leagueTime = league.match_date.indexOf(' ') != -1 ? league.match_date.split(' ')[1] : league.match_date
        let leagueDate = league.match_date.indexOf(' ') != -1 ? league.match_date.split(' ')[0] : league.match_date

        league.matchTime = leagueTime.split(':')[0] + ':' + leagueTime.split(':')[1]
        league.matchDate = leagueDate

        return league
      })

      return k
    }
  },
  /*watch: {
    matchesHighlights() {
      this.highlights = this.$store.state.game.matchesHighlights
      return this.highlights
    }
  },*/
  methods: {
    next_1() {
      this.currentHightlight_1 += 1
    },
    previous_1() {
      if (!this.currentHightlight_1) this.currentHightlight_1 = this.desktopHighlights_1.length - 1
      else this.currentHightlight_1 -= 1
    },
    next_2() {
      this.currentHightlight_2 += 1
    },
    previous_2() {
      if (!this.currentHightlight_2) this.currentHightlight_2 = this.desktopHighlights_2.length - 1
      else this.currentHightlight_2 -= 1
    },
    changeLanguage(language) {
      this.$store.dispatch(`${SHARED.LOADING}`)
      uiHelper.removeCookie('language')
      uiHelper.setCookie('language', language)
      window.location.reload()
    },
    getMatchesHighlights() {
      this.$store.dispatch(`${GAME_MATCHES_HIGHLIGHTS}`)
    },
    matchUp(league) {
      if (moment(league.match_date).isSame(new Date(), 'day')) {
        return 'Live'
      } else if (moment(league.match_date).isAfter(new Date(), 'day')) {
        return 'Pre-match'
      } else {
        return 'Hot'
      }
    }
  }
}
</script>

<style lang="scss">
.highlight-container {
  background-color: var(--v-text_reverse-base);

  .highlight-height {
    height: 420px;
  }

  .highlight-wrapper {
    max-width: 1240px;
    margin: auto;

    .matches-box-desktop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      color: var(--v-text_reverse-base);

      .matches-box-desktop-1,
      .matches-box-desktop-2 {
        width: 100%;

        .matches-box-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: var(--v-background_2-base);
          height: 40px;
          border-radius: 5px 5px 0px 0px;

          .matches-box-header-title {
            margin: 12px;
          }

          .matches-box-header-control {
            display: flex;
            margin-right: 12px;

            .header-divider {
              height: 40px;
              width: 1px;
              background: rgba(255, 255, 255, 0.3);
              margin: 0px 4px;
            }

            .header-icon {
              color: #ffa60c;
              cursor: pointer;
            }

            .v-icon.v-icon::after {
              background-color: unset;
            }
          }
        }

        .matches-box-body {
          max-width: 614px;
          max-height: 400px;
          background: var(--v-base-base);
          border-radius: 0px 0px 5px 5px;
          border: 1px solid var(--v-primary-base);

          .match-item-desktop {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 32px;
            color: black;
            width: 100%;
            height: 100%;
            background: url('/static/image/favourite/footballfield.webp');
            background-size: cover;
            background-position: center;
            //background-attachment: fixed;
            background-repeat: no-repeat;
          }
        }
      }
    }

    .matches-label {
      position: relative;
      border-left: 4px solid var(--v-primary-base);
      padding-left: 4px;
    }

    .matches-box {
      position: relative;
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;
      padding-bottom: 15px;

      .matchUp {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
      }

      .match-item {
        width: 320px !important;
        height: 200px !important;
        position: relative;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        color: black;
        background: url('../../../public/static/svg/Live Match_BG.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        //padding: 12px;
        cursor: pointer;
        text-decoration: none;
        //height: 350px;
        border-radius: 10px;
      }
    }

    .league-name {
      font-size: 14px;
      text-align: center;
      color: white;
      padding-top: 5px;
      padding-bottom: 10px;
      //font-weight: bold;
      //filter: drop-shadow(1px 1px 1px #001101);
    }

    .match-datetime-div {
      line-height: 1.2;
      color: white;
      //filter: drop-shadow(1px 1px 1px #001101);
      .match-date {
        font-size: 14px;
        text-align: center;
      }
      .match-time {
        font-size: 14px;
        text-align: center;
        //font-weight: bold;
      }
    }

    .match-team {
      display: flex;
      flex-direction: row;
      gap: 12px;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      width: 100%;
      font-size: 14px;
      //font-weight: bold;
      //filter: drop-shadow(1px 1px 1px #001101);

      .country-logo {
        width: 100px;
        height: 100px;
      }

      .vs-team {
        font-size: 36px;
      }
      .verDiv {
        margin-top: auto;
        margin-bottom: auto;
        .versus {
          width: 40px;
          height: 30px;
        }
      }

      .odds {
        font-weight: normal;
        background: white;
        border-radius: 25px;
        margin-top: 10px;
      }
    }

    .cricket-name-header {
      text-overflow: ellipsis;
      overflow: hidden;
      width: auto;
      white-space: nowrap;
    }

    .live_container {
      height: 40px;
      width: -webkit-fill-available;
      background-image: linear-gradient(180deg, #0047ff 0%, #5a00b4 100%);
      font-size: 16px !important;
      display: flex;
      justify-content: center;
      padding-top: 10px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
}
.home-team,
.away-team {
  width: 40%;
}
@media (max-width: 959px) {
  .highlight-container {
    .highlight-height {
      height: 290px;
    }

    .highlight-wrapper {
      .matches-box {
        .match-item {
          min-width: 240px;
          min-height: 150px;
          height: 164px;
          gap: 2px;
          padding: 8px 0 0 0;
          justify-content: normal;

          .league-name {
            font-size: 12px;
          }

          .match-date {
            //font-size: 14px;
          }

          .match-team {
            font-size: 12px;
            padding-top: 15px !important;

            .team-name {
              height: 35px;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              color: black;
            }

            .home-team {
            }

            .away-team {
            }

            .country-logo {
              width: 60px;
              height: 60px;
            }
            .odds {
              font-size: 12px;
              font-weight: normal;
              color: black;
            }
            .vs-team {
              font-size: 26px;
            }
            .versus {
              width: 47px;
              height: 30px;
            }
          }

          .match-datetime-div {
            .match-date {
              font-size: 10px;
              font-weight: normal;
            }
            .match-time {
              font-size: 18px;
              //font-weight: bold;
            }
          }
          .live_container {
            height: 40px;
            background-image: linear-gradient(180deg, #0047ff 0%, #5a00b4 100%);
            font-size: 16px !important;
            display: flex;
            justify-content: center;
            padding-top: 10px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 959px) {
  .highlight-container .highlight-wrapper .matches-box .match-item {
    width: 450px !important;
    height: 230px !important;
  }
  .highlight-container .highlight-wrapper .match-team {
    padding-bottom: 20px !important;
  }
}
</style>
